import {EventEmitter, Injectable} from '@angular/core';
import {CartoService} from './carto.service';
import {environment} from '../../environments/environment';

export enum MatchStatus {
  NotStarted = 0,
  Quarter1 = 1,
  Break = 2,
  Quarter2 = 3,
  Quarter3 = 4,
  Quarter4 = 5,
  Finished = 7,
  Suspended = 8,
  Postponed = 9,
  Overtime = 10,
  Cancelled = 100
}

export interface IEvent {
  event_id: number;
  zone_id: number;
  player_id: number;
  quarter: number;
  failures: number;
  faults: number;
  points: number;
  shots: number;
  time: number;
  x: number;
  y: number;
  team_0: number;
  player_0_id: number;
  player_1_id: number;
  score_home: number;
  score_visitor: number;
}

@Injectable()
export class MatchService extends CartoService {
  TABLE_GAME = `${environment.carto.tablePreffix}game${environment.carto.tableSuffix}`;
  TABLE_GAME_PLAYER = `${environment.carto.tablePreffix}game_player${environment.carto.tableSuffix}`;
  TABLE_EVENT = `${environment.carto.tablePreffix}event${environment.carto.tableSuffix}`;
  TABLE_STATS_PLAYER = `${environment.carto.tablePreffix}stats_player${environment.carto.tableSuffix}`;
  TIMER_SECONDS = 10;

  socket: any;
  timer: any;
  private refreshEventSource = new EventEmitter<any>();
  refreshEvent$ = this.refreshEventSource.asObservable();

  getGame(gameId: number): Promise<any> {
    return this.queryData(`
      select
        competition,
        time as date,
        place,
        stage,
        day,
        status,
        (
          SELECT row_to_json(tm1)
          FROM (
            select home as name, home_code as code, home_id as id,
              (
                select array_to_json(array_agg(row_to_json(p)))
                from (
                  select player_id as id, player_name as name, number, frontline, position, team_id, game_id
                  from ${this.TABLE_GAME_PLAYER}
                  where
                    game_id = ${gameId} and
                    team_id = ${this.TABLE_GAME}.home_id
                    order by frontline DESC, player_id ASC
                  ) p
              ) as players
            FROM ${this.TABLE_GAME}
            WHERE id = ${gameId}
          ) tm1
        ) as home,
        (
          select row_to_json(tm2)
          from (
            select visitor as name , visitor_code as code, visitor_id as id,
              (
                select array_to_json(array_agg(row_to_json(p)))
                from (
                    select player_id as id, player_name as name, number, position, frontline, team_id, game_id
                    from ${this.TABLE_GAME_PLAYER}
                    where
                      game_id = ${gameId} and
                      team_id = ${this.TABLE_GAME}.visitor_id
                      order by frontline DESC, player_id ASC
                  ) p
              ) as players
            FROM ${this.TABLE_GAME}
            WHERE id = ${gameId}
          ) tm2
        ) as visitor
      from ${this.TABLE_GAME}
      WHERE id = ${gameId}
    `);
  }

  getGameEvents(gameId: number, sinceId: number = null): Promise<IEvent[]> {
    let idCondition = '';
    if (sinceId !== null) {
      idCondition = ` AND event_id > ${sinceId} `;
    }
    return this.queryData(`
      SELECT event_id, grid_id, zone_id, player_0_id, player_1_id, quarter, failures, faults,
             points, shots, (600 - (minute * 60 + second)) as time, team_0,
             ST_X(ST_Transform(the_geom, 4326)) as x, ST_Y(ST_Transform(the_geom, 4326)) as y,
             score_home, score_visitor
      FROM ${this.TABLE_EVENT}
      WHERE game_id=${gameId}${idCondition}
      ORDER BY event_id ASC
    `);
  }

  getGameStats(gameId: number): Promise<any[]> {
    return this.queryData(`
      with max_player_time as (
        SELECT MAX(time) max, player_id
        FROM ${this.TABLE_STATS_PLAYER} stats
        WHERE game_id=${gameId}
        and exists (
          select * FROM ${this.TABLE_GAME_PLAYER}
          where game_id=${gameId} and  stats.player_id = player_id
        )
        group by player_id
      )
      SELECT st.player_id, points, rebounds_attack, rebounds_defense, assists, played_time,
      fouls, rating, score_success_rate AS accuracy, playing, quarter,  m.max  as time
      FROM ${this.TABLE_STATS_PLAYER} st, max_player_time m
      WHERE st.player_id = m.player_id
      AND st.time = m.max
      and game_id=${gameId}
      GROUP BY st.player_id, points, rebounds_attack, rebounds_defense, assists, played_time,
      fouls, rating, accuracy, playing, quarter, m.max
    `);
  }

  connectSocket(matchId) {
    if (!this.socket) {
      // this.socket = new WebSocket(`${environment.websocketURL}${matchId}`);
      this.socket = new WebSocket(`${environment.websocketURL}`);
      this.socket.onmessage = (e) => {
        if (e.data !== 'alive') {
          this.refreshEventSource.next();
        }
      };
    }
  }

  closeSocket() {
    if (this.socket) {
      this.socket.close();
    }
  }

  startTimer() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        this.refreshEventSource.next();
      }, this.TIMER_SECONDS * 1000);
    }
  }

  stopTimer() {
    clearInterval(this.timer);
    this.timer = null;
  }

  getTeamImg({code, id}) {
    // return `${environment.teamAssetsUrl}/${code.toLowerCase()}-${id}/badge.png`;
    return `${environment.teamUrl}/${id}.app.png?$General$&wid=144&hei=144`; // 86
  }

  getPlayerImg(team, playerId) {
    //return `${environment.teamAssetsUrl}/${team.code.toLowerCase()}-${team.id}/${playerId}.jpg`;
    return `${environment.playerUrl}/${playerId}.jpg?$General$&wid=102&hei=102`; //620
  }
}



// WEBPACK FOOTER //
// ./src/app/services/match.service.ts